const ARROW_HEAD_LENGTH_RATIO = 0.18;
const ARROW_HEAD_MAX_LENGTH = 42;
const ARROW_HEAD_MIN_LENGTH = 12;
const ARROW_HEAD_SHAFT_LIMIT = 0.45;
const ARROW_HEAD_WIDTH_RATIO = 0.42;
const MIN_ARROW_LENGTH = 0.001;

const clamp = (value, minimum, maximum) =>
  Math.min(Math.max(value, minimum), maximum);

const getHeadLength = (arrowLength) => {
  if (arrowLength < MIN_ARROW_LENGTH) return 0;

  const proportionalLength = clamp(
    arrowLength * ARROW_HEAD_LENGTH_RATIO,
    ARROW_HEAD_MIN_LENGTH,
    ARROW_HEAD_MAX_LENGTH
  );
  return Math.min(proportionalLength, arrowLength * ARROW_HEAD_SHAFT_LIMIT);
};

/**
 * Returns the stable, semantic geometry of an open arrowhead. Visual marker
 * wobble is added by the renderer and never changes these selectable bounds.
 * @param {{ x1: number, y1: number, x2: number, y2: number }} points
 * @returns {{ leftWing: { x: number, y: number }, rightWing: { x: number, y: number }, tip: { x: number, y: number } }}
 */
export const getArrowHeadPoints = (points) => {
  const deltaX = points.x2 - points.x1;
  const deltaY = points.y2 - points.y1;
  const arrowLength = Math.hypot(deltaX, deltaY);
  const headLength = getHeadLength(arrowLength);
  const halfWidth = headLength * ARROW_HEAD_WIDTH_RATIO;
  const tangentX = arrowLength ? deltaX / arrowLength : 1;
  const tangentY = arrowLength ? deltaY / arrowLength : 0;
  const normalX = -tangentY;
  const normalY = tangentX;
  const baseX = points.x2 - tangentX * headLength;
  const baseY = points.y2 - tangentY * headLength;

  return {
    leftWing: {
      x: baseX + normalX * halfWidth,
      y: baseY + normalY * halfWidth,
    },
    rightWing: {
      x: baseX - normalX * halfWidth,
      y: baseY - normalY * halfWidth,
    },
    tip: { x: points.x2, y: points.y2 },
  };
};
